export default {
  drop_files: 'Drag and Drop your file here or BROWSE',
  browse: 'BROWSE',
  file_upload: 'Upload Files',
  error: 'Cannot load the file!',
  error_too_large: 'The file is too large!',
}
